import { CircularProgress, Stack, Typography } from "@mui/material";

export default function PageLoader({ text }) {
  return (
    <Stack direction="column" alignItems="center" spacing={3}>
      <CircularProgress />
      <Typography>{text}</Typography>
    </Stack>
  );
}
